<template>
  <JoszakiAutocomplete
    :value="value"
    v-bind="$attrs"
    icon="tag"
    :items="filteredServiceTypes"
    exclude-selected
    :loading="loading"
    @search="onSearch"
    @focus="onFocus"
    @input="$emit('input', $event)"
    v-on="$listeners"
  >
    <template #empty>
      {{ $t("conductor.common.noResults") }}
    </template>
  </JoszakiAutocomplete>
</template>

<script>
import { ref } from "@nuxtjs/composition-api";
import { useServiceTypeActions } from "~/components/_refactored/conductor/service-types/useServiceTypeActions";

export default {
  props: {
    value: {
      type: [Object, Array],
      default: () => null,
    },
    itemsMapper: {
      type: Function,
      default: (item) => item,
    },
  },
  setup(props, { emit }) {
    const { getServiceTypes } = useServiceTypeActions();
    const filteredServiceTypes = ref([]);
    const loading = ref(false);

    const onSearch = async (search) => {
      loading.value = true;
      const { items } = await getServiceTypes({
        search,
        page: 1,
        pageSize: 15,
      });
      filteredServiceTypes.value = items.map(props.itemsMapper);
      loading.value = false;
    };

    const onFocus = (search) => {
      if (!filteredServiceTypes.value.length) {
        onSearch(search ?? "");
      }
      emit("focus", search);
    };

    return {
      filteredServiceTypes,
      onSearch,
      onFocus,
      loading,
    };
  },
};
</script>
